var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { MenubarPathStep_ } from './Step/MenubarPathStep_';
let MenubarPathMobile_ = class MenubarPathMobile_ extends React.PureComponent {
    render() {
        const { app } = this.props;
        if (!app.menubarPath.menubarLocation)
            return null;
        return (React.createElement("nav", { style: {
                display: 'flex',
                background: 'linear-gradient(rgb(60, 60, 60) 0%, rgb(34, 34, 34) 100%)',
                flexDirection: 'column'
            } }, app.menubarPath.steps.map(step => React.createElement(MenubarPathStep_, { step: step, key: step.depth }))));
    }
};
MenubarPathMobile_ = __decorate([
    observer
], MenubarPathMobile_);
export { MenubarPathMobile_ };
